import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { ICardViewThematicStrategy } from 'src/models/products.model';

@Component({
  selector: 'liberro-thematic-strategy-card',
  standalone: false,
  templateUrl: './liberro-thematic-strategy-card.component.html',
  styleUrl: './liberro-thematic-strategy-card.component.less'
})
export class LiberroThematicStrategyCardComponent {
  @Input() public variant: 'list' | 'rotation' = 'rotation';
  @Input({ required: true }) public thematicStrategy!: ICardViewThematicStrategy;
  @Output() public strategySelected = new EventEmitter<number>();
  public tooltipVisible = signal<boolean>(false);

  public selectStrategy(): void {
    this.strategySelected.emit(this.thematicStrategy.modelStrategyId);
  }

  public tooltipToggle(visible: boolean): void {
      this.tooltipVisible.set(visible);
  }
}
